import { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import useIsMounted from '@hooks/useIsMounted'
import { RoleInfo } from '@models/role.model'
import { OptionsContext } from '@contexts/Options'
import { KeyValPair } from '@models/common.model'
import { Box, Container, Grid, MenuItem, Select, Stack, Typography } from '@mui/material'
import CustomizedAccordions from './accordion'
import CustomizedSearch from './search'

export default function DialogContent({
	list,
	options,
	selectedUsers,
	setSelectedUsers,
	handleSearchRolesByProject,
	handleInputSearch,
	setInputValueSearched,
	inputValueSearched
}: {
	list?: any
	options?: KeyValPair[]
	selectedUsers?: string[]
	setSelectedUsers?:any
	handleSearchRolesByProject?:any
	handleInputSearch?:any
	setInputValueSearched?:any
	inputValueSearched?:any
}) {
	const { t } = useTranslation()

	const refMounted = useRef(true)
	const isMounted = useIsMounted()

	const { control } = useFormContext()
	const { state } = useContext(OptionsContext)

	const roleIds = useWatch({ name: 'role_ids', control })
	console.debug('list', list)
	useEffect(() => {
		console.log('dialog rerender')
	}, [])

	return (
		<Box sx={{padding: '0'}}>
			<Grid container spacing={0.5} sx={{height: '60px'}}>
				<Grid item xs={12} sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginX: '30px'}}>
					<CustomizedSearch value={[]} sx={{ width: '100%' }} handleInputSearch={handleInputSearch} handleOnSearch={(selectedValue) => {}} setInputValueSearched={setInputValueSearched} inputValueSearched={inputValueSearched}/>
				</Grid>
			</Grid>
			<Stack>
				{/* <CustomizedAccordions list={list} selectedGroups={selectedGroups} setSelectedGroups={setSelectedGroups}/> */}
				<CustomizedAccordions list={list} selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers}/>
			</Stack>
		</Box>
	)
}
